import { useContext, useMemo } from 'react';
import { AuthContext, CommonContext } from '@repo-level/core-front';

import { formatWalletValue } from 'helpers/wallet';

export function useCurrentOptionWallet() {
  const { user, wallets } = useContext(AuthContext);

  const currentOptionWallet = useMemo(() => {
    return (
      wallets.find(({ currency }) => currency === user?.currency) || wallets[0]
    );
  }, [user, wallets]);

  return currentOptionWallet;
}

export function useFormatCurrentOptionWallet(withSymbol?: boolean) {
  const { currencies } = useContext(CommonContext);

  const { amountCents, currency: currencyCode } = useCurrentOptionWallet();

  return formatWalletValue(currencyCode, amountCents, currencies, withSymbol);
}

export function useMaxAmountValue() {
  const { currencies } = useContext(CommonContext);
  const { user, extendedWallets: wallets } = useContext(AuthContext);

  const currentOptionWallet = useMemo(() => {
    if (!wallets) return null;
    return (
      wallets.find(({ currency }) => currency === user?.currency) || wallets[0]
    );
  }, [user, wallets]);

  if (!currentOptionWallet) return null;

  const { currency, availableToCashoutCents } = currentOptionWallet;
  return formatWalletValue(
    currency,
    availableToCashoutCents,
    currencies
  ) as number;
}
